import { Plugins } from '@leverege/plugin';
import DefaultSortConverter from "./DefaultSortConverter.js";
export default Plugins.createFactory('OpenApiAttributeSortConverter', {
  pluginKey: 'convert',
  defaultObject: DefaultSortConverter
});